import * as moment from 'moment';

export abstract class SharedQuestion {

    private _questionDisplayed:boolean = false;
    private displayedAt:Moment;
    private lastValidTimer:Moment;
    private time:Duration;

    private validationCallbacks: (() => void)[] = [];
    private shouldCallValidation: boolean = true;

    question: IQuestion = null;

    public isValid(): boolean {
        if (this.shouldCallValidation)
            this.validation();

        return false;
    }

    abstract getValue(): IValue[]|IValue;
    abstract setValue(value:IValue[]|IValue);
    abstract satisfiesValue(currentValues:IValue[], value:IValue): boolean;

    public validationMessage() : string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'default_validation_message';
    }

    protected getMessage(type: string): string {
        if (this.question.meta.messages) {
            for (let message of this.question.meta.messages) {
                if (message.type === 'required') {
                    return message.value;
                }
            }
        }

        return null;
    }

    protected validation() {
        this.preventValidation(() => {
            this.validationCallbacks.forEach((callback) => callback());
        });
    }

    public preventValidation(callback: () => void) {
        this.shouldCallValidation = false;
        callback();
        this.shouldCallValidation = true;
    }

    public afterValidation(callback: () => void): () => void {
        let index = this.validationCallbacks.push(callback) - 1;

        return () => {
            this.validationCallbacks.splice(index, 1);
        };
    }

    public questionDisplayed() {
        this._questionDisplayed = true;
        this.displayedAt = moment().utc();
        this.lastValidTimer = moment().utc();
    }

    public isQuestionDisplayed():boolean {
        return this._questionDisplayed;
    }

    public sessionPaused() {
        if (!this._questionDisplayed || this.lastValidTimer == null) {
            throw new Error("Cannot pause session that is not started");
        }

        this.getQuestionTime();
    }

    public sessionResumed() {
        this.lastValidTimer = moment().utc();
    }

    public getQuestionTime():Duration {
        let toAdd = moment.duration(moment().utc().diff(this.lastValidTimer));
        this.time = this.time == null ? toAdd : this.time.add(toAdd);
        this.lastValidTimer = moment().utc();

        return this.time;
    }

    public questionAnswered(reset?: boolean) {
        if (!this._questionDisplayed || this.lastValidTimer == null) {
            throw new Error("Cannot answer question when session is not active");
        }

        let timing = {
            displayedAt: this.displayedAt,
            answeredAt: moment().utc(),
            time: this.getQuestionTime()
        };

        if (reset) {
            this._questionDisplayed = false;
            this.displayedAt = null;
            this.lastValidTimer = null;
            this.time = null;
        }

        return timing;
    }

    // @TODO: implement for all questions!
    isAnswerEmpty(answer: IAnswer): boolean {
        throw 'Missing implementation';
    }

}